import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { IPriceProps, IProduct } from '../types';
import { getFormattedPrice } from '../utils/price';

export interface IInjectedPriceProps {
  priceData?: IPriceProps;
}

const withPriceData = <
  P extends {
    product: IProduct;
  }
>(
  Component: React.ComponentType<P>
): React.FC<P> => {
  let priceData: IPriceProps = {
    isPromo: false,
    price: null,
    priceRange: null,
    defaultPrice: null,
    minimumPrice: null,
    salePriceEffectiveDate: null
  };

  return (props: P) => {
    const { product } = props;
    const config = useSelector((state: RootState) => state.app.config);

    if (!config.currency && !config.localeId) {
      return null;
    }

    if (product) {
      priceData = getFormattedPrice(priceData, product, {
        currency: config.currency,
        localeId: config.localeId
      });
    }

    return <Component {...props} priceData={priceData} />;
  };
};

export default withPriceData;
